module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[29]150.07bf415.woff2";